import { useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import useTags from 'hooks/useTags';

import PaginationComponent from 'components/segments/Pagination';
import ErrorDialogue from 'components/segments/ErrorDialogue';
import DeleteDialogue from 'components/segments/DeleteDialogue';
import { TableBox } from 'components/segments/StyledComponents';

const List = () => {
  const listOnLoad = useRef();
  const {
    tags,
    currentPage,
    pages,
    // count,
    isRequesting,
    lastUpdateError,
    getTagsList,
    // updateStatus,
    deleteTag
  } = useTags();

  const navigate = useNavigate();

  useEffect(() => {
    if (!listOnLoad.current) {
      listOnLoad.current = true;
      getTagsList({ page: currentPage || 1 });
    }
  }, [currentPage, getTagsList, tags]);

  const errorDisplay = useMemo(() => {
    if (!tags?.length) {
      const message =
        !listOnLoad.current || isRequesting ? 'Loading tags...' : 'Sorry, no tags found';
      return <Heading size='lg'>{message}</Heading>;
    }
    return null;
  }, [tags?.length, isRequesting]);

  const pageChangeHandler = page => {
    getTagsList({ page, sort: { field: 'created', dir: -1 } });
  };

  const handleDelete = tag => {
    if (tag) {
      deleteTag({ tag });
    }
  };

  return (
    <Box>
      {errorDisplay}
      {!errorDisplay && (
        <TableBox my='12px' border='1px solid #000'>
          <Table size='sm'>
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Value</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {tags.map((l, idx) => {
                return (
                  <Tr key={idx}>
                    <Td>{l.name}</Td>
                    <Td>{l.value}</Td>
                    <Td>
                      <ButtonGroup spacing='3' size='xs'>
                        <Button onClick={() => navigate(`/tags/edit/${l._id}`)}>Edit</Button>
                        <DeleteDialogue
                          label='Delete'
                          deleteConfirmLabel='Delete Tags'
                          handleDelete={() => handleDelete(l._id)}
                        />
                      </ButtonGroup>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableBox>
      )}
      <ErrorDialogue error={lastUpdateError} />
      {pages > 1 && (
        <PaginationComponent
          numPages={pages}
          page={currentPage}
          pageChangeHandler={pageChangeHandler}
        />
      )}
    </Box>
  );
};

export default List;
